module.exports = __webpack_public_path__ + "img/arrow-turn-down-left.fa24600f.svg";